import reducer from "./reducer";

export { fetchContacts } from "./actions";
export * from "./selectors";

export default reducer;
